import React, { useState, useEffect, useRef } from "react";
import {
  Header,
  CardItem,
  FilterLabel,
  UpArrow,
  FilterButton,
  MobileFilterButton,
  FilterCategory,
  AlertMessage
} from "../components";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import {
    identifyNumber,
    countOffset,
    pageCounter,
    handleScrollUp,
    objectAlphabetSort,
    getBaseURL
} from "../helpers/helpers";
import Pagination from '@mui/material/Pagination';
import useTelegram from "../hooks/useTelegram";
import useCheckTelegramId from "../hooks/useCheckTelegramId";

function MainPage() {

    const BOT_URL = process.env.REACT_APP_API_TELEGRAM_BOT_URL;
    const [products, setProducts] = useState([]);
    const [filtersValues, setFiltersValues] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [checkState, setCheckState] = useState({});
    const [productCounter, setProductCounter] = useState();
    const [categories, setCategories] = useState();
    /* window width */
    const [isFiltersVisible, setIsFiltersVisible] = useState(false);
    const [filtersButtons, setFiltersButton] = useState(false);
    const [expandedCategories, setExpandedCategories] = useState([]);
    const [dynamicFilters, setDynamicFilters] = useState({});
    const [pagesCount, setPagesCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [page, setPage] = useState(1);
    const [showTitle, setShowTitle] = useState(true);
    let mainContStyles = productCounter === 0 ? 'display-block' : 'display-flex';

    const { user, isReady } = useTelegram();
    const { checkTelegramId } = useCheckTelegramId();

    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isIdNotRegistered, setIsIdNotRegistered] = useState(false);
    const [isIdNotFound, setIsIdNotFound] = useState(false);
    const [brandName, setBrandName] = useState('');

    const wrapperRef = useRef(null);

    useEffect(() => {
        if (isAuthorized && wrapperRef.current) {
            const currentWrapper = wrapperRef.current;
            currentWrapper.addEventListener("click", handleWrapperClick);

            return () => {
                currentWrapper.removeEventListener("click", handleWrapperClick);
            };
        }
    }, [isAuthorized]);

    const handleWrapperClick = (event) => {
        // Проверяем, что клик был внутри wrapper и вне области .category-options
        if (wrapperRef.current && wrapperRef.current.contains(event.target)) {
            let element = event.target;

            // Поднимаемся по DOM дереву, чтобы проверить, не находится ли элемент внутри .category-options
            while (element !== wrapperRef.current) {
                if (element.classList.contains("category-options")) {
                    return; // Если элемент внутри .category-options, прерываем функцию
                }
                element = element.parentNode;
            }

            // Если клик был не в области .category-options
            if (isFiltersVisible) {
                setExpandedCategories([]);
                console.log("Клик в пределах filter__container__wrapper, но вне .category-options");
            }
        }
    }

    useEffect(() => {
        if (productCounter) {
            setPagesCount(pageCounter(productCounter));
        }
    }, [productCounter]);

    useEffect(() => {
        const checkAuthorization = async () => {
            if (isReady && user?.id) {
                const { isAuthorized, brand } = await checkTelegramId(user?.id.toString());
                setIsAuthorized(isAuthorized);
                setIsIdNotRegistered(!isAuthorized);
                setBrandName(brand);
            } else if (isReady && !user?.id) {
                console.log("User ID is not available");
                setIsIdNotFound(true);
                setIsAuthorized(false);
            }
        };

        checkAuthorization();
    }, [isReady, user?.id, checkTelegramId]);

    function checkScreenSize() {
        if (window.innerWidth >= 992) {
            setShowTitle(true);
        } else {
            setShowTitle(false);
        }
    }


    useEffect(() => {
        if (isAuthorized)
            FetchData();
    }, [filtersValues, offset, isAuthorized]);

    useEffect(() => {
        if (inputValue) {
            FetchData();
        }
    }, [inputValue]);

    useEffect(() => {
        checkScreenSize();

        window.addEventListener('resize', checkScreenSize);

        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, [checkScreenSize]);

    const FetchData = async () => {
        try {
            const res = await fetch(getBaseURL(brandName), {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "query": inputValue,
                    "filters": filtersValues,
                    "offset": offset
                })
            });
            const responseJSON = await res.json();
            mainContStyles = productCounter === 0 || products.length === 0 ? 'display-block' : 'display-flex';
            let newFilters = responseJSON.response.filters || {};
            objectAlphabetSort(newFilters);

            const categorie = Object.keys(newFilters).reduce((acc, category) => {
                acc[category] = transformOptions(newFilters[category]);
                return acc;
            }, {});
            setCategories(categorie);
            setCheckState(categorie);
            updateCheckedFilters();

            let productCount = responseJSON.response.total;
            setProductCounter(productCount);
            setProducts(responseJSON.response.results || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    /* show filters at mobile */
    const handleShowFilters = () => {
        setIsFiltersVisible(!isFiltersVisible);
        setFiltersButton(!filtersButtons);
        console.log(isFiltersVisible);
    }

    function findIndexForItem(array, itemToFind) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] === itemToFind) {
                return i;
            }
        }
        return -1;
    }

    const transformOptions = (options) => {
        return options.reduce((acc, option) => {
            acc[option] = false;
            return acc;
        }, {});
    };

    const handleChange = (category, option) => (event) => {
        resetPage();
        const updatedCheckState = {
            ...checkState,
            [category]: {
                ...checkState[category],
                [option]: event.target.checked
            }
        };

        setCheckState(updatedCheckState);

        handleFilterChange(category, option);

        const existingFilterIndex = filtersValues.findIndex(filter => filter.filter_name === category);

        if (existingFilterIndex !== -1) {
            if (filtersValues[existingFilterIndex].filter_values.some(item => item === option)) {
                setFiltersValues(prevFilters => {
                    const updatedFilters = [...prevFilters];
                    const index = findIndexForItem(updatedFilters[existingFilterIndex].filter_values, option);
                    updatedFilters[existingFilterIndex].filter_values.splice(index, 1);
                    if (updatedFilters[existingFilterIndex].filter_values.length === 0) {
                        updatedFilters.splice(existingFilterIndex, 1);
                        return updatedFilters;
                    } else {
                        return updatedFilters;
                    }
                });
            } else {
                setFiltersValues(prevFilters => {
                    const updatedFilters = [...prevFilters];
                    updatedFilters[existingFilterIndex].filter_values.push(option);
                    return updatedFilters;
                });
            }
        } else {
            const filterObject = {
                "filter_name": category,
                "filter_values": [option]
            };
            setFiltersValues(prevFilters => [...prevFilters, filterObject]);
        }

    };

    /* input */
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    /* submit within input */
    const handleInputSubmit = (event) => {
        if (event.key === 'Enter') {
            FetchData();
        }
    };

    const handleSubmit = () => {
        FetchData();
    };

    const removeFilter = (filterName) => {
        resetPage();
        setFiltersValues(prevFilters => prevFilters.filter(filter => filter.filter_name !== filterName));

        setCheckState(prevState => {
            return {
                ...prevState,
                [filterName]: Object.fromEntries(
                    Object.entries(prevState[filterName] || {}).map(([key, value]) => [key, false])
                )
            };
        });

        setDynamicFilters(prevState => {
            return {
                ...prevState,
                [filterName]: Object.fromEntries(
                    Object.entries(prevState[filterName] || {}).map(([key, value]) => [key, false])
                )
            };
        });
    };

    const removeAllFilters = () => {
        setFiltersValues([]);
        setDynamicFilters({});
        setCheckState(categories);
    };

    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: "#401100",
        '&:hover': {
            backgroundColor: "#300d00",
        },
        width: "92px",
        borderRadius: "4px"
    }));

    const toggleCategory = (category, event) => {
        event.stopPropagation();
        setExpandedCategories(prevCategories => {
            if (prevCategories.includes(category)) {
                return prevCategories.filter(cat => cat !== category); // Collapsing
            } else {
                return [...prevCategories, category]; // Expanding
            }
        });
    };

    const handleFilterChange = (category, option) => {

        const updatedDataFilters = { ...checkState };
        updatedDataFilters[category][option] = !updatedDataFilters[category][option];

        const updatedDynamicFilters = { ...dynamicFilters };

        if (updatedDataFilters[category][option]) {
            if (!updatedDynamicFilters[category]) {
                updatedDynamicFilters[category] = {};
            }
            updatedDynamicFilters[category][option] = true;
        } else {
            if (updatedDynamicFilters[category]) {
                delete updatedDynamicFilters[category][option];
                if (Object.keys(updatedDynamicFilters[category]).length === 0) {
                    delete updatedDynamicFilters[category];
                }
            }
        }
        // Update state
        setDynamicFilters(updatedDynamicFilters);
        console.log(updatedDynamicFilters);
    }

    const updateCheckedFilters = () => {
        setCheckState((prevFilters) => {
            const updatedFilters = { ...prevFilters };

            for (const category in dynamicFilters) {
                if (category in updatedFilters) {
                    for (const key in dynamicFilters[category]) {
                        if (key in updatedFilters[category]) {
                            updatedFilters[category][key] = dynamicFilters[category][key];
                        }
                    }
                }
            }
            return updatedFilters;
        });
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        setOffset(countOffset(value));
        handleScrollUp();
    };

    const resetPage = () => {
        setPage(1);
        setOffset(0);
    }

    if (!isReady) {
        return null;
    }

    if (!isAuthorized) {
        return (
            <>
                <Header brandName={brandName} />
                <AlertMessage
                    show={isIdNotRegistered}
                    onClose={() => setIsIdNotRegistered(false)}
                    message={`Ваш telegram Id ${user?.id} не було знайдено`}
                />
                <AlertMessage
                    show={isIdNotFound}
                    onClose={() => setIsIdNotFound(false)}
                    message="Будь ласка, авторизуйтесь у"
                    link={BOT_URL}
                />
            </>
        );
    }

    return (
        <>
            <Header brandName={brandName} />
            <div className="container">

                <div className="search__wrapper">
                    <h3 className="title search__title">Пошук товарів</h3>
                    <div className="search__container">
                        <input className="search-input" onChange={handleInputChange} onKeyDown={handleInputSubmit}/>
                        <ColorButton onClick={handleSubmit}>Пошук</ColorButton>
                    </div>
                </div>

                <div className={`product__container ${isFiltersVisible ? 'show' : ''}`}>
                {showTitle && (
                    <div className="product-title">Підібрати товар</div>
                )}
                    <div className="product-counter">Підібрано {productCounter} {identifyNumber(productCounter)}</div>
                    {Array.isArray(filtersValues) && filtersValues.length > 0 && (
                        <div className="product--clear" onClick={removeAllFilters}>
                            Очистити все
                        </div>
                    )}
                </div>

                <div className={`main__container ${mainContStyles}`}>

                    <div className={`filter__container ${isFiltersVisible && filtersButtons ? 'show' : ''}`}>
                        <div className="filter__container__wrapper" ref={wrapperRef}>
                            <div className={`filter__mobile__description ${isFiltersVisible ? 'show' : ''}`}>
                                <div className="filter__mobile_close" onClick={handleShowFilters}></div>
                                <div className={`filter__mobile_title ${isFiltersVisible ? 'show' : ''}`}>Фільтрувати</div>
                                {Array.isArray(filtersValues) && filtersValues.length > 0 && (
                                    <div className="product--clear" onClick={removeAllFilters}>
                                        Очистити все
                                    </div>
                                )}
                            </div>
                            <div className={`filter__mobile_button ${isFiltersVisible ? '' : 'show'}`}>
                                <div className="filter__button" onClick={handleShowFilters}>
                                    <div>Показати товари</div>
                                    <div className="filter__mobile_counter ">{productCounter}</div>
                                </div>
                            </div>
                            <div className="filter__mobile_inner">
                                {Object.entries(checkState).map(([category, options]) => (
                                    <FilterCategory
                                        key={category}
                                        category={category}
                                        options={options}
                                        isExpanded={expandedCategories.includes(category)}
                                        toggleCategory={(e) => toggleCategory(category, e)}
                                        handleChange={handleChange}
                                        filtersValues={filtersValues}
                                        removeFilter={removeFilter} />
                                ))}

                            </div>
                        </div>
                    </div>

                    <div className="right__container">

                        <div className="label__container">
                            {Array.isArray(filtersValues) && filtersValues.length > 0 && (
                                <FilterButton
                                    onClick={handleShowFilters}
                                    className="label__child" />
                            )}

                            {Array.isArray(filtersValues) && filtersValues.length === 0 && (
                                <MobileFilterButton onClick={handleShowFilters} />
                            )}

                            {filtersValues &&
                                filtersValues.map((filter) => (
                                    filter.filter_name && (
                                        <FilterLabel className="label__child"
                                            key={filter.filter_name}
                                            filterName={filter.filter_name}
                                            filterCounter={filter.filter_values.length}
                                            filterOption={filter.filter_values}
                                            onRemove={removeFilter} />
                                    )
                                ))
                            }

                            {Array.isArray(filtersValues) && filtersValues.length > 0 && (
                                <p className="filter__title--mobile label__child">Більше фільтрів</p>
                            )}

                        </div>

                        <div className={`mobile-data__wrapper ${isFiltersVisible ? '' : 'show'}`}>
                            <div className="mobile-data__counter">{productCounter} {identifyNumber(productCounter)}</div>
                        </div>

                        <div className="product-grid__wrapper">
                            <div className="product-grid">
                                {products.map((product, index) => (
                                    <CardItem
                                        key={index}
                                        name={product.name}
                                        code={product.code}
                                        picture={product.picture}
                                        presence={product.presence}
                                        url={product.url}
                                        minWeight={product.min_weight}
                                        maxWeight={product.max_weight}
                                        minPrice={product.min_price}
                                        maxPrice={product.max_price}
                                        sizes={product.sizes}
                                    />
                                ))}
                            </div>
                        </div>
                        <Pagination
                            className="pagination"
                            count={pagesCount}
                            variants='outlined'
                            shape='rounded'
                            page={page}
                            onChange={handlePageChange} />
                    </div>
                </div>
                <UpArrow />

            </div>
        </>
    );
}

export default MainPage;
